import styled from '@emotion/styled';

export default function AuthLoadingScreen() {
  return (
    <Container>
      <ContentBox>
        <LogoWrapper>
          <LogoImage src="/logo-128.png" alt="WalkyCam" />
          <PulseRing />
        </LogoWrapper>
        <Title>WalkyCam</Title>
        <Subtitle>Verificando credenciales de acceso...</Subtitle>
        <ProgressBar>
          <ProgressIndicator />
        </ProgressBar>
      </ContentBox>
    </Container>
  );
}

const Container = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--walky-canvas);
  color: var(--walky-ink);
  z-index: 9999;
  padding: 24px;
`;

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 360px;
  width: 100%;
`;

const LogoWrapper = styled.div`
  position: relative;
  width: 88px;
  height: 88px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoImage = styled.img`
  width: 72px;
  height: 72px;
  border-radius: 18px;
  object-fit: cover;
  box-shadow: 0 12px 28px rgba(244, 90, 10, 0.28);
  position: relative;
  z-index: 2;
`;

const PulseRing = styled.div`
  position: absolute;
  inset: -6px;
  border-radius: 24px;
  border: 2px solid var(--walky-orange);
  opacity: 0.7;
  animation: pulse-ring 1.8s cubic-bezier(0.24, 0, 0.38, 1) infinite;

  @keyframes pulse-ring {
    0% {
      transform: scale(0.9);
      opacity: 0.8;
    }
    50% {
      transform: scale(1.15);
      opacity: 0.3;
    }
    100% {
      transform: scale(0.9);
      opacity: 0.8;
    }
  }
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 800;
  margin: 0 0 6px 0;
  letter-spacing: -0.02em;
  color: var(--walky-ink);
`;

const Subtitle = styled.p`
  font-size: 14px;
  color: var(--walky-muted);
  margin: 0 0 24px 0;
  font-weight: 500;
`;

const ProgressBar = styled.div`
  width: 160px;
  height: 4px;
  background: var(--walky-border);
  border-radius: 9999px;
  overflow: hidden;
  position: relative;
`;

const ProgressIndicator = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50%;
  background: linear-gradient(90deg, var(--walky-orange), #ff8438);
  border-radius: 9999px;
  animation: indeterminate 1.4s ease-in-out infinite;

  @keyframes indeterminate {
    0% {
      left: -50%;
    }
    100% {
      left: 100%;
    }
  }
`;
